import { useCallback, useState } from 'react'

export const useCallErrors = () => {
  const [callErrors, setCallError] = useState<string[]>([])

  const addCallError = useCallback((error) => {
    setCallError((prevState) => [...prevState, error])
  }, [])

  return {
    callErrors,
    addCallError,
  }
}
